import { SkeletonCard, SkeletonTable } from "./skeleton";

export function LoadingPage() {
  return (
    <div className="space-y-6">
      <div>
        <div className="h-10 w-64 animate-pulse rounded-lg bg-slate-800" />
        <div className="mt-3 h-4 w-96 animate-pulse rounded-lg bg-slate-800" />
      </div>

      <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>

      <SkeletonTable />
    </div>
  );
}